import { inkItemTokens } from '@ds/tokens'

const tokens = {
  activeBackgroundColor: inkItemTokens.itemBgColorActive,
  hoverBackgroundColor: inkItemTokens.itemBgColorHover,
  selectedBackgroundColor: inkItemTokens.itemBgColorSelected,
} as const

export default tokens
